import Vue from 'vue'

export default {
  state: {
    currentNewsletterArray: [],
    deletedNewsletterEntry: null
  },
  getters: {
    getCurrentNewsletterArray: state => state.currentNewsletterArray,
  },
  actions: {
    downloadNewsletterEmails: ({commit}, payload) => {
      // payload = {
      //   page:1
      // }
      return Vue.axios.post('newsletter/getAll', payload).then(response => {
        if(response.status == 200){
          commit('SET_NEWSLETTER_ARRAY', response.data)
          // state.downloadAlbums = response.data
        }
        return response
      }).catch(err => {
        return err
      })
    },
    downloadNewsletterEmailsCSV: () => {
        window.open(process.env.VUE_APP_API_URL + "/newsletter/getCSV?secret=X6UtO5Mou3H1bJrCYHa4LKTlsNdxwEEOi9kff89TUSbxQWIr3ezmwVmzj");
        // return Vue.axios.get('newsletter/getCSV').then(response => {
        //   // if(response.status == 200){
        //   //   commit('SET_NEWSLETTER_ARRAY2', response.data)
        //   //   // state.downloadAlbums = response.data
        //   // }
        //   return response
        // }).catch(err => {
        //   return err
        // })


    },
    deleteNewsletterEmail: ({commit},emailObj) => {
      return Vue.axios.post('newsletter/delete/' + emailObj.id).then(response => {
        if(response.status == 200){
          commit('SET_DELETE_NEWSLETTER_ENTRY', response.data)
        }
        return response
      }).catch(err => {
        return err
      })
    },
  },
  mutations: {
    SET_NEWSLETTER_ARRAY: (state, payload) => {
      state.currentNewsletterArray = payload
    },
    SET_DELETE_NEWSLETTER_ENTRY: (state, payload) => {
      state.deletedNewsletterEntry = payload
    },
  },
}
